<!--
 * @Author: DYM
 * @Date: 2020-03-16 15:49:24
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 11:10:33
 * @Description: 用户信息
 -->
<template>
  <hm-page-card
    class="c-card--table"
    title="所选用户身份信息"
  >
    <template v-slot:extra>
      <el-button
        type="success"
        icon="kestrel-icon ki-plus"
        @click="handleAddCapacity()"
      >
        新增
      </el-button>
      <el-button
        type="success"
        icon="kestrel-icon ki-edit"
        plain
        :disabled="!selectedRow.capacityCode"
        @click="handleBtnClick('edit')"
      >
        修改
      </el-button>
      <el-button
        type="primary"
        icon="kestrel-icon ki-user"
        :disabled="!selectedRow.capacityCode || selectedRow.isPrimary==='Y'"
        @click="handleBtnClick('changeToMain')"
      >
        变更为主身份
      </el-button>
      <el-button
        type="primary"
        icon="kestrel-icon ki-link"
        plain
        :disabled="!selectedRow.capacityCode"
        @click="handleBtnClick('relateRole')"
      >
        关联岗位
      </el-button>
      <el-button
        type="primary"
        icon="kestrel-icon ki-cog"
        plain
        :disabled="!selectedRow.capacityCode"
        @click="handleBtnClick('relatePermissionDept')"
      >
        数据权限配置
      </el-button>
    </template>

    <div
      class="c-page__pTable"
    >
      <!-- table的ref的命名根据业务名称修改 -->
      <el-table
        ref="capacityTable"
        class="c-page__table o-header-text-center"
        height="100%"
        stripe
        border
        highlight-current-row
        tooltip-effect="dark"
        :data="page.rows"
        :class="{ 'o-table-empty-center': page.rows.length <= 0 }"
        :row-class-name="tableRowClassName"
        @row-click="handleRowClick"
      >
        <el-table-column
          class-name="c-table-column--selection"
          width="30"
        >
          <template
            slot-scope="scope"
          >
            <el-radio
              v-model="selectedRow.capacityCode"
              :label="scope.row.capacityCode"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="capacityCode"
          label="身份代码"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="capacityName"
          label="身份名称"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="effectStartDate"
          label="身份有效期起"
          min-width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.effectStartDate | date('yyyy-MM-dd') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="effectEndDate"
          label="身份有效期止"
          min-width="100"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.effectEndDate | date('yyyy-MM-dd') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="deptName"
          label="所属组织"
          min-width="140"
          show-overflow-tooltip
        />
        <el-table-column
          prop="validName"
          label="有效标志"
          width="80"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="isPrimaryName"
          label="是否主身份"
          width="80"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="sourceTypeName"
          label="数据来源"
          width="80"
          align="center"
          show-overflow-tooltip
        />
        <template v-for="(attrCapacityItem, index) in attrCapacityList">
          <template v-if="attrCapacityItem.attrType==='Date'">
            <el-table-column
              :key="'attrCapacity'+ index"
              :prop="attrCapacityItem.attrKey"
              :label="attrCapacityItem.attrName"
              width="120"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row[attrCapacityItem.attrKey] | date('yyyy-MM-dd') }}
              </template>
            </el-table-column>
          </template>
          <template v-else-if="attrCapacityItem.enums">
            <el-table-column
              :key="'attrCapacity'+ index"
              :prop="attrCapacityItem.attrKey"
              :label="attrCapacityItem.attrName"
              :min-width="attrCapacityItem.attrName.length > 3 ? attrCapacityItem.attrName.length * 24 : 90"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row[attrCapacityItem.attrKey+'_name'] }}
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
              :key="'attrCapacity'+ index"
              :prop="attrCapacityItem.attrKey"
              :label="attrCapacityItem.attrName"
              :min-width="attrCapacityItem.attrName.length > 3 ? attrCapacityItem.attrName.length * 24 : 90"
              show-overflow-tooltip
            />
          </template>
        </template>
      </el-table>
      <el-pagination
        class="c-page__pagination"
        :disabled="page.total<=0 || isLoading"
        :page-size="page.pageSize"
        :total="page.total"
        :current-page="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10,15,20]"
        @current-change="search"
        @size-change="handleSizeChange"
      />
    </div>
  </hm-page-card>
</template>

<script>
import { capacityService, attrCapacity } from '../user.service';

export default {
  name: 'Capacity',
  props: {
    userCode: {
      type: String,
      default: null
    },
    userSourceType: {
      type: String,
      default: '0'
    },
    isLoading: Boolean,
    isSearch: Boolean
  },
  data () {
    return {
      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 查询条件 Start */
      filterParams: {
        userCode: null
      },
      /*  查询条件 End */

      selectedRow: {}, // 用户列表选中行

      /* 扩展字段 Start */
      attrUserList: [], // 用户
      attrCapacityList: [] // 身份
      /* 扩展字段 End */
    };
  },
  methods: {
    /**
     * @description: 获取扩展字段
     * @param {*}
     * @return {*}
     */
    getAttr () {
      // 获取用户扩展字段
      attrCapacity()
        .then(rsp => {
          this.attrCapacityList = rsp.data;
          this.$emit('update:attrCapacity', rsp.data);
          this.$nextTick(() => {
            this.$refs.capacityTable.doLayout();
          });
        })
        .catch(err => {
          console.error('获取用户扩展信息错误！', err);
        });
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 start */
      this.filterParams.pageSize = this.page.pageSize;
      this.filterParams.pageNo = _pageNo;
      /* 处理分页参数 start */
      this.filterParams.userCode = this.userCode;

      this.$emit('update:isLoading', true);
      capacityService.list(this.filterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
        })
        .catch(err => {
          console.error('查询身份列表出错', err);
        })
        .finally(() => {
          this.$emit('update:isLoading', false);
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 表格行背景颜色渲染处理
     * 背景色提供：is-warning(黄色)，is-danger(红色)，is-success(绿色)
     * （右键操作搭配is-warning）
     * @param {Object}
     * @return {*}
     */
    tableRowClassName ({ row, rowIndex }) {
      if (this.$HMUtil.Objdiff(row, this.contextMenuRow)) {
        return 'is-warning';
      }
      return '';
    },
    /**
     * @description: 点击操作按钮触发事件
     * @param {String} key,操作类型
     * @return {*}
     */
    handleBtnClick (key) {
      switch (key) {
        case 'edit':
          this.handleEditCapacity();
          break;
        case 'changeToMain':
          this.handleToMainCapacity(this.selectedRow.capacityCode, this.selectedRow.capacityName);
          break;
        case 'relateRole':
          this.$emit('dialogControl', 'relateRole', this.selectedRow);
          break;
        case 'relatePermissionDept':
          this.$emit('dialogControl', 'relatePermissionDept', this.selectedRow);
          break;
        default:
          break;
      }
    },
    handleEditCapacity () {
      if (this.selectedRow.sourceType === '1') {
        this.$alert('当前用户信息数据来源为“同步”，不能修改身份！', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      this.$emit('dialogControl', 'edit', { capacityCode: this.selectedRow.capacityCode });
    },
    /**
     * @description: 变更为主身份
     * @param {String} _capacityCode，身份uuid
     * @param {String} _capacityName，身份名称
     * @return {*}
     */
    handleToMainCapacity (_capacityCode, _capacityName) {
      const _this = this;
      if (_this.selectedRow.sourceType === '1') {
        _this.$alert('当前用户信息数据来源为“同步”，不能变更主身份！', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      _this.$confirm(`是否确认将身份【${_capacityName}】更为用户主身份？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$emit('update:isLoading', true);
        capacityService.changeToMain(_capacityCode)
          .then(rsp => {
            _this.$alert('更改成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search(_this.filterParams.pageNo);
            _this.$emit('update:isLoading', false);
          })
          .catch(() => {
            _this.$emit('update:isLoading', false);
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 表格选中行事件
     * @param {Object} row
     * @param {Object} column
     * @param {any} event
     * @return {*}
     */
    handleRowClick (row, column, event) {
      this.selectedRow = row;
    },
    /**
     * @description: 新增用户身份
     * @param {*}
     * @return {*}
     */
    handleAddCapacity () {
      if (!this.userCode) {
        this.$alert('请选择要新增身份的用户！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      if (this.userSourceType === '1') {
        this.$alert('当前用户信息数据来源为“同步”，不能新增身份！', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      this.$emit('handleAddCapacity');
    }
  },
  watch: {
    userCode: function (newVal) {
      if (newVal) {
        this.search(1);
        this.selectedRow = {};
      } else if (newVal === null) {
        this.selectedRow = {};
        this.page = {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNo: 0
        };
      }
    },
    isSearch: function (newVal) {
      if (newVal) {
        this.search(this.filterParams.pageNo);
        this.$emit('update:isSearch', false);
      }
    }
  },
  created () {
    this.getAttr();
  }
};
</script>
